import { render, staticRenderFns } from "./DefinitionDialog.vue?vue&type=template&id=3a39bf94&scoped=true"
import script from "./DefinitionDialog.vue?vue&type=script&lang=js"
export * from "./DefinitionDialog.vue?vue&type=script&lang=js"
import style0 from "./DefinitionDialog.vue?vue&type=style&index=0&id=3a39bf94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a39bf94",
  null
  
)

export default component.exports